export default __webpack_public_path__ + "static/RMDS-retail-e74adf8241448350eac2dad9db510840.png";